import React from 'react';
import PropTypes from 'prop-types';
import { AppBar, Tabs, Tab } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import NavbarMenu from "../../../../Components/SharesNavbarMenu";
import PendingPlansTab from './PendingPlansTab';
import RejectedPlansTab from './RejectedPlansTab';
import "./Plans.css";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`plans-tabpanel-${index}`}
      aria-labelledby={`plans-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div className="py-2">
          {children}
        </div>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `plans-tab-${index}`,
    'aria-controls': `plans-tabpanel-${index}`,
  };
}

export default function Plans({ setFundData }) {
  const [value, setValue] = React.useState(0);
  const history = useHistory();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleBackToDashboard = () => {
    history.push('/shares-platform');
  };

  return (
    <>
      <NavbarMenu />

      <div className="plans-wrapper">
        <button
          onClick={handleBackToDashboard}
          className="back-to-dashboard-btn"
          title="Back to Dashboard"
        >
          <ArrowBackIcon />
        </button>
        <h1 className="plans-title">Plans</h1>

        <div className="mt-2">
          <AppBar position="static" className="plans-tabs-appbar" style={{ backgroundColor: '#00695C', boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
            <Tabs
              value={value}
              onChange={handleChange}
              TabIndicatorProps={{ style: { backgroundColor: '#FFFFFF', height: 4 } }}
              aria-label="plans tabs"
              variant="scrollable"
              className="plans-tabs"
            >
              <Tab
                label="Pending Plans"
                {...a11yProps(0)}
                style={{
                  color: value === 0 ? '#00695C !important' : '#FFFFFF !important',
                  fontWeight: value === 0 ? 'bold' : '600',
                  fontSize: '1.1rem',
                  textTransform: 'none',
                  minWidth: '150px',
                  opacity: 1
                }}
              />
              <Tab
                label="Rejected Plans"
                {...a11yProps(1)}
                style={{
                  color: value === 1 ? '#00695C !important' : '#FFFFFF !important',
                  fontWeight: value === 1 ? 'bold' : '600',
                  fontSize: '1.1rem',
                  textTransform: 'none',
                  minWidth: '150px',
                  opacity: 1
                }}
              />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <PendingPlansTab setFundData={setFundData} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <RejectedPlansTab />
          </TabPanel>
        </div>
      </div>
    </>
  );
}
